import { Avatar, Box, Skeleton, Typography } from "@mui/material";
import ClosedCard from "components/ClosedCard";
import { Colors } from "helpers/Consts";
import { IPlace } from "types/Place";

type Props = {
  place: IPlace | undefined;
};

/**
 * Exibe informações do 'Restaurante' (Place)
 * @param place
 * @constructor
 */
function RestaurantContainer({ place }: Props) {
  return (
    <Box>
      <Box sx={{ position: "relative", marginTop: "10px", padding: 0 }}>
        {place?.data ? (
          <>
            <Box
              component="img"
              sx={{
                borderRadius: "7px",
                width: "100%",
                height: { xs: "180px", sm: "200px", md: "280px" },
              }}
              src={place?.data.cover_image}
              alt={place?.data.name}
            />
            {place?.data.closed && <ClosedCard place={place} />}
          </>
        ) : (
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              borderRadius: "7px",
              width: "100%",
              height: { xs: "180px", sm: "200px", md: "280px" },
            }}
          />
        )}
      </Box>
      <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
        {place?.data ? (
          <Avatar
            variant="rounded"
            alt={place?.data.name}
            src={place?.data.logo_image}
            sx={{ width: "56px", height: "56px" }}
          />
        ) : (
          <Skeleton
            variant="circular"
            sx={{ width: "56px", height: "56px" }}
            animation="wave"
          />
        )}
        {place?.data ? (
          <>
            <Typography
              variant="h5"
              color="black"
              sx={{
                fontWeight: { xs: "700", sm: "400" },
                marginLeft: "10px",
                fontSize: { xs: "11px", sm: "20px" },
              }}
            >
              {place?.data.name}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Typography
              color={Colors.baseTextColor}
              sx={{ fontSize: { xs: "11px", sm: "15px" } }}
            >
              {place?.data.delivery_min_time} ~ {place?.data.delivery_max_time}{" "}
              min
            </Typography>
          </>
        ) : (
          <Skeleton
            variant="text"
            sx={{ width: "80%", marginLeft: "10px" }}
            animation="wave"
          />
        )}
      </Box>
    </Box>
  );
}

export default RestaurantContainer;
